import DSLog from 'DsWebLogSender'

export const LogScreenName = Object.freeze({
  MARKET_CART: 'Market/Cart',
  MARKET_ORD: 'Market/Ord',
  MARKET_ORD_HIST: 'Market/OrdHist',
  MARKET_ORD_DET: 'Market/OrdDet',
  MARKET_ORD_PURCH_METHOD: 'Market/Ord/PurchMethod',
  ORD: 'Ord',
  ORD_CPN: 'Ord/Cpn'
})

export const LogType = Object.freeze({
  VIEW: 'View',
  CLICK: 'Click'
})

export const LogGroup = Object.freeze({
  DEFAULT: '',
  CART_DET: 'CartDet',
  PRODUCT_DET: 'ProductDet',
  ORD: 'Ord',
  CALL: 'Call',
  APPLY: 'Apply',
  OrdCpn: 'OrdCpn',
  LIVE_CHAT: 'LiveChat'
})

export const LogEvent = Object.freeze({
  DEFAULT: '',
  ORD: 'Ord',
  PRODUCT_DET: 'ProductDet',
  DEL_ORD: 'DelOrd',
  CENTER_CALL: 'CenterCall',
  DELETE: 'Delete',
  ALL_SELECT: 'AllSelect',
  QTY: 'Qty',
  MORE: 'More',
  RESERVATION: 'Reservation',
  TIME_SET: 'TimeSet',
  PURCH_METHOD: 'PurchMethod',
  DEL_ORD_CNCL: 'DelOrdCncl',
  CPN: 'Cpn',
  SELECT: 'Select',
  LIVE_CHAT_CENTER: 'LiveChatCenter'
})

class AppLogManager {
  constructor() {
    DSLog.init({
      table: 'weblog-common',
      env: process.env.VUE_APP_APP_LOG_ENV,
      field: {
        screenName: '',
        group: '',
        service: 'baemin-market'
      }
    })
  }

  init({ memberId, memberNo, sessionId, deviceId, appVersion }) {
    this.memberId = memberId
    this.memberNo = memberNo
    this.sessionId = sessionId
    this.deviceId = deviceId
    this.version = appVersion
  }

  postAppLog({ memberNo, sessionId, deviceId, screenName, type, group, event, params }) {
    const unixTimestamp = Math.floor(new Date().getTime() / 1000)
    new Promise(() => {
      DSLog.log({
        timestamp: unixTimestamp,
        memNo: memberNo,
        sessionId,
        dvcId: deviceId,
        screenName,
        type,
        group,
        event,
        params
      })
    }).then()
  }

  post({ screenName, type, params, group = LogGroup.DEFAULT, event = LogEvent.DEFAULT }) {
    this.postAppLog({
      memberNo: this.memberNo,
      sessionId: this.sessionId,
      deviceId: this.deviceId,
      screenName,
      type,
      group,
      event,
      params
    })
  }

  getDefaultParams() {
    return {
      mem_no: this.memberNo,
      device_id: this.deviceId,
      session_id: this.sessionId,
      user_id: this.memberId,
      version: this.version
    }
  }
}

export default AppLogManager
